import { render, staticRenderFns } from "./CommonEnergyPriceSettings.vue?vue&type=template&id=64c0d242&scoped=true&"
import script from "./CommonEnergyPriceSettings.vue?vue&type=script&lang=ts&"
export * from "./CommonEnergyPriceSettings.vue?vue&type=script&lang=ts&"
import style0 from "./CommonEnergyPriceSettings.vue?vue&type=style&index=0&id=64c0d242&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c0d242",
  null
  
)

export default component.exports